<template>
    <div>
      <Component :is="componentByPartner" v-bind="{partner, currentCountry}" />
    </div>
</template>

<script>
import { State } from 'vuex-class'
import { Vue, Component, Prop } from 'vue-property-decorator'

import WhereIsMyAccuralsAlfa from './WhereIsMyAccuralsAlfa'
import WhereIsMyAccuralsTinkoff from './WhereIsMyAccuralsTinkoff'

import { PARTNERS } from '@/constants'

const COMPONENT_BY_PARTNER = {
  [PARTNERS.ALFABANK_BY]: WhereIsMyAccuralsAlfa,
  [PARTNERS.ALFA_BY]: WhereIsMyAccuralsAlfa,
  [PARTNERS.TBANK]: WhereIsMyAccuralsTinkoff
}

@Component({
  components: {
    WhereIsMyAccuralsAlfa,
    WhereIsMyAccuralsTinkoff
  }
})
class WhereIsMyAccurals extends Vue {
  @State('country') currentCountry

  @Prop({ type: String, required: true }) partner

  get componentByPartner () {
    if (!this.partner) return null
    return COMPONENT_BY_PARTNER[this.partner]
  }
}
export default WhereIsMyAccurals
</script>
